import './DisciplineChips.css';

const DISCIPLINES = [
    { value: 'architecture', label: 'Architecture' },
    { value: 'structural', label: 'Structural' },
    { value: 'mechanical', label: 'Mechanical' },
    { value: 'electrical', label: 'Electrical' },
    { value: 'plumbing', label: 'Plumbing' },
];

export function disciplineLabel(value) {
    return DISCIPLINES.find(d => d.value === value)?.label ?? value;
}

/**
 * Toggle-pill picker for a model's disciplines. Never inferred (a model's
 * sheets and folder describe how a team organizes documents, not which
 * discipline's geometry the file holds) — an admin always states this
 * directly, which is what this control exists for.
 *
 * `readOnly` renders the same pills without the toggle affordance, so a
 * group's view-mode row and its edit-mode row share one component.
 */
export const DisciplineChips = ({ value, onChange, readOnly = false }) => {
    if (readOnly) {
        return (
            <span className="mg-discipline-chips">
                {value.length === 0 && <span className="mg-discipline-chip mg-discipline-chip-empty">No discipline</span>}
                {value.map(d => (
                    <span key={d} className="mg-discipline-chip mg-discipline-chip-active">{disciplineLabel(d)}</span>
                ))}
            </span>
        );
    }

    const toggle = (d) => {
        onChange(value.includes(d) ? value.filter(v => v !== d) : [...value, d]);
    };

    return (
        <span className="mg-discipline-chips" role="group" aria-label="Disciplines">
            {DISCIPLINES.map(({ value: d, label }) => (
                <button
                    key={d}
                    type="button"
                    className={`mg-discipline-chip${value.includes(d) ? ' mg-discipline-chip-active' : ''}`}
                    aria-pressed={value.includes(d)}
                    onClick={() => toggle(d)}
                >
                    {label}
                </button>
            ))}
        </span>
    );
};
